/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Credits_Tab_ConsumeInputs */

const en_settings_credits_tab_consume = /** @type {(inputs: Settings_Credits_Tab_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consume`)
};

const zh_settings_credits_tab_consume = /** @type {(inputs: Settings_Credits_Tab_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消耗`)
};

/**
* | output |
* | --- |
* | "Consume" |
*
* @param {Settings_Credits_Tab_ConsumeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_credits_tab_consume = /** @type {((inputs?: Settings_Credits_Tab_ConsumeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_Tab_ConsumeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_credits_tab_consume(inputs)
	return zh_settings_credits_tab_consume(inputs)
});
export { settings_credits_tab_consume as "settings.credits.tab_consume" }